var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEngaged(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.19 0H5.81C2.17 0 0 2.17 0 5.81V14.18C0 17.83 2.17 20 5.81 20H14.18C17.82 20 19.99 17.83 19.99 14.19V5.81C20 2.17 17.83 0 14.19 0Z",
    fill: "url(#paint0_linear_148_1367)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33011 13.24C5.17011 13.24 5.01011 13.19 4.87011 13.08C4.54011 12.83 4.48011 12.36 4.73011 12.03L7.11011 8.94001C7.40011 8.57001 7.81011 8.33001 8.28011 8.27001C8.74011 8.21001 9.21011 8.34001 9.58011 8.63001L11.4101 10.07C11.4801 10.13 11.5501 10.13 11.6001 10.12C11.6401 10.12 11.7101 10.1 11.7701 10.02L14.0801 7.04001C14.3301 6.71001 14.8101 6.65001 15.1301 6.91001C15.4601 7.16001 15.5201 7.63001 15.2601 7.96001L12.9501 10.94C12.6601 11.31 12.2501 11.55 11.7801 11.6C11.3101 11.66 10.8501 11.53 10.4801 11.24L8.65011 9.80001C8.58011 9.74001 8.50011 9.74001 8.46011 9.75001C8.42011 9.75001 8.35011 9.77001 8.29011 9.85001L5.91011 12.94C5.78011 13.14 5.56011 13.24 5.33011 13.24Z",
    fill: "url(#paint1_linear_148_1367)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_148_1367",
    x1: 9.99502,
    y1: 0,
    x2: 9.99502,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF5EDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA4BC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_148_1367",
    x1: 9.99912,
    y1: 6.74805,
    x2: 9.99912,
    y2: 13.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5B7E9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngaged);
export default __webpack_public_path__ + "97120/static/media/Engaged.0e78443d6f6304982ca116aabcd8ad91.svg";
export { ForwardRef as ReactComponent };